import React, { useEffect, useState } from "react";
import layoutConf from "../../config/layoutConf";

import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";

import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import CreateRecordButton from "../input/CreateRecordButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";

function MomSysInspectinEntity(props) {
    const [height, setHeight] = useState(0);

    const [inspectionItemSchema, setInspectionItemSchema] = useState();
    const [inspectionCriteriaSchema, setInspectionCriteriaSchema] = useState();
    const [inspectionGroupSchema, setInspectionGroupSchema] = useState();
    const [inspectionListSchema, setInspectionListSchema] = useState();

    const [inspectionItemGrid, setInspectionItemGrid] = useState();
    const [inspectionCriteriaGrid, setInspectionCriteriaGrid] = useState();
    const [inspectionGroupGrid, setInspectionGroupGrid] = useState();
    const [inspectionListGrid, setInspectionListGrid] = useState();

    /***
    const [inspectionItemData, setInspectionItemData] = useState();
    const [inspectionCriteriaData, setInspectionCriteriaData] = useState();
    const [inspectionGroupData, setInspectionGroupData] = useState();
    const [inspectionListData, setInspectionListData] = useState();
    ***/

    const [inspectionItemIsEmpty, setInspectionItemIsEmpty] = useState();
    const [inspectionCriteriaIsEmpty, setInspectionCriteriaIsEmpty] = useState();
    const [inspectionGroupIsEmpty, setInspectionGroupIsEmpty] = useState();
    const [inspectionListIsEmpty, setInspectionListIsEmpty] = useState();

    const [inspectionItemInstance, setInspectionItemInstance] = useState();
    const [inspectionCriteriaInstance, setInspectionCriteriaInstance] = useState();
    const [inspectionGroupInstance, setInspectionGroupInstance] = useState();
    const [inspectionListInstance, setInspectionListInstance] = useState();

    const [inspectionGroupSelect, onInspectionGroupSelect] = useState();

    const { t } = useTranslation();

    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        let mounted = true;

        window.addEventListener("resize", handleResize);
        handleResize();

        (async () => {
            if (mounted) {
                let inspectionItemSchema = await getSchema("MomSysInspectionItem");
                setInspectionItemSchema(inspectionItemSchema);

                let inspectionCriteriaSchema = await getSchema("MomSysInspectionCriteria");
                setInspectionCriteriaSchema(inspectionCriteriaSchema);

                let inspectionGroupSchema = await getSchema("MomSysInspectionGroup");
                setInspectionGroupSchema(inspectionGroupSchema);
            }
        })();

        return () => {
            mounted = false;
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        let mounted = true;

        (async () => {
            if (inspectionGroupSelect && mounted) {
                let schema = await getSchema("MomSysInspectionList");

                for (let column of schema.columns) {
                    switch (column.name) {
                        case "inspectionGroupId":
                            column.defaultValue = inspectionGroupSelect.inspectionGroupId;
                            break;
                        default:
                            break;
                    }
                }

                setInspectionListSchema(schema);
            }
        })();

        setInspectionListInstance((instance) => {
            if (instance) {
                instance.refresh();
            }

            return instance;
        });

        return () => {
            mounted = false;
        };
    }, [inspectionGroupSelect]);

    useEffect(() => {
        let mounted = true;

        (async () => {
            if (inspectionGroupGrid && mounted) {
                inspectionGroupGrid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        onInspectionGroupSelect(grid.selectedItems[0]);
                    }
                });

                inspectionGroupGrid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        onInspectionGroupSelect(grid.selectedItems[0]);
                    }
                });
            }
        })();

        return () => {
            mounted = false;
        };
    }, [inspectionGroupGrid]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    return (
        <div style={{ height: height }}>
            <ReflexContainer orientation="vertical">
                <ReflexElement flex={0.4}>
                    <ReflexContainer orientation="horizontal">
                        <ReflexElement flex={0.5}>
                            <BasicCrudScreenType
                                id={"MomSysInspectionItem-create"}
                                headerTitle={t("term.momSysInspectionItem")}
                                table={"MomSysInspectionItem"}
                                view={"MomSysVwInspectionItem"}
                                onInitialized={(grid) => {
                                    setInspectionItemGrid(grid);
                                }}
                                onApiInitialized={(instance) => {
                                    setInspectionItemInstance(instance);
                                }}
                                onLoadData={(data) => {
                                    setInspectionItemIsEmpty(data.length < 1 ? true : false);
                                }}
                                noCreate
                                noEdit
                                noDelete
                                noExcel
                                onAppendButtonInFrontOfSearch={() => (
                                    <React.Fragment>
                                        <BasicCrudScreenActionItemLayout>
                                            <CreateRecordButton
                                                id={"MomSysInspectionItem-create-button"}
                                                schema={inspectionItemSchema}
                                                refresh={inspectionItemInstance}
                                                onSuccess={onSuccess}
                                            />
                                            <UpdateRecordButton
                                                id={"MomSysInspectionItem-update-button"}
                                                schema={inspectionItemSchema}
                                                grid={inspectionItemGrid}
                                                refresh={inspectionItemInstance}
                                                disabled={inspectionItemIsEmpty}
                                                onSuccess={onSuccess}
                                            />
                                            <DeleteRecordButton
                                                id={"MomSysInspectionItem-delete-button"}
                                                schema={inspectionItemSchema}
                                                grid={inspectionItemGrid}
                                                refresh={inspectionItemInstance}
                                                color="secondary"
                                                disabled={inspectionItemIsEmpty}
                                                onSuccess={onSuccess}
                                                onFailure={onFailure}
                                            />
                                        </BasicCrudScreenActionItemLayout>
                                    </React.Fragment>
                                )}
                            />
                        </ReflexElement>

                        <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                        <ReflexElement flex={0.5}>
                            <BasicCrudScreenType
                                id={"MomSysInspectionCriteria"}
                                headerTitle={t("term.momSysInspectionCriteria")}
                                table={"MomSysInspectionCriteria"}
                                view={"MomSysVwInspectionCriteria"}
                                onInitialized={(grid) => {
                                    setInspectionCriteriaGrid(grid);
                                }}
                                onApiInitialized={(instance) => {
                                    setInspectionCriteriaInstance(instance);
                                }}
                                onLoadData={(data) => {
                                    setInspectionCriteriaIsEmpty(data.length < 1 ? true : false);
                                }}
                                noCreate
                                noEdit
                                noDelete
                                noExcel
                                onAppendButtonInFrontOfSearch={() => (
                                    <React.Fragment>
                                        <BasicCrudScreenActionItemLayout>
                                            <CreateRecordButton
                                                id={"MomSysInspectionCriteria-create-button"}
                                                schema={inspectionCriteriaSchema}
                                                refresh={inspectionCriteriaInstance}
                                                onSuccess={onSuccess}
                                            />
                                            <UpdateRecordButton
                                                id={"MomSysInspectionCriteria-update-button"}
                                                schema={inspectionCriteriaSchema}
                                                grid={inspectionCriteriaGrid}
                                                refresh={inspectionCriteriaInstance}
                                                disabled={inspectionCriteriaIsEmpty}
                                                onSuccess={onSuccess}
                                            />
                                            <DeleteRecordButton
                                                id={"MomSysInspectionCriteria-delete-button"}
                                                schema={inspectionCriteriaSchema}
                                                grid={inspectionCriteriaGrid}
                                                refresh={inspectionCriteriaInstance}
                                                color="secondary"
                                                disabled={inspectionCriteriaIsEmpty}
                                                onSuccess={onSuccess}
                                                onFailure={onFailure}
                                            />
                                        </BasicCrudScreenActionItemLayout>
                                    </React.Fragment>
                                )}
                            />
                        </ReflexElement>
                    </ReflexContainer>
                </ReflexElement>

                <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />

                <ReflexElement flex={0.6}>
                    <ReflexContainer orientation="horizontal">
                        <ReflexElement flex={0.4}>
                            <BasicCrudScreenType
                                id={"MomSysInspectionGroup"}
                                headerTitle={t("term.momSysInspectionGroup")}
                                table={"MomSysInspectionGroup"}
                                view={"MomSysVwInspectionGroup"}
                                onInitialized={(grid) => {
                                    setInspectionGroupGrid(grid);
                                }}
                                onApiInitialized={(instance) => {
                                    setInspectionGroupInstance(instance);
                                }}
                                onLoadData={(data) => {
                                    setInspectionGroupIsEmpty(data.length < 1 ? true : false);
                                }}
                                noCreate
                                noEdit
                                noDelete
                                noExcel
                                onAppendButtonInFrontOfSearch={() => (
                                    <React.Fragment>
                                        <BasicCrudScreenActionItemLayout>
                                            <CreateRecordButton
                                                id={"MomSysInspectionGroup-create-button"}
                                                schema={inspectionGroupSchema}
                                                refresh={inspectionGroupInstance}
                                                onSuccess={onSuccess}
                                            />
                                            <UpdateRecordButton
                                                id={"MomSysInspectionGroup-update-button"}
                                                schema={inspectionGroupSchema}
                                                grid={inspectionGroupGrid}
                                                refresh={inspectionGroupInstance}
                                                disabled={inspectionGroupIsEmpty}
                                                onSuccess={onSuccess}
                                            />
                                            <DeleteRecordButton
                                                id={"MomSysInspectionGroup-delete-button"}
                                                schema={inspectionGroupSchema}
                                                grid={inspectionGroupGrid}
                                                refresh={inspectionGroupInstance}
                                                color="secondary"
                                                disabled={inspectionGroupIsEmpty}
                                                onSuccess={onSuccess}
                                                onFailure={onFailure}
                                            />
                                        </BasicCrudScreenActionItemLayout>
                                    </React.Fragment>
                                )}
                            />
                        </ReflexElement>

                        <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                        <ReflexElement flex={0.6}>
                            {inspectionGroupSelect?.inspectionGroupId ? (
                                <BasicCrudScreenType
                                    id="MomSysInspectionList"
                                    headerTitle={t("term.momSysInspectionList")}
                                    table="MomSysInspectionList"
                                    view="MomSysVwInspectionList"
                                    onModifyViewSchema={(schema) => {
                                        if (schema) {
                                            for (const column of schema.columns) {
                                                switch (column.name) {
                                                    case "inspectionGroupName":
                                                        column.grid.hide = true;
                                                        column.filter = null;
                                                        break;

                                                    default:
                                                        break;
                                                }
                                            }
                                        }
                                    }}
                                    onModifyViewUrl={(url) => {
                                        return url + "/" + inspectionGroupSelect.inspectionGroupId;
                                    }}
                                    onInitialized={(grid) => {
                                        setInspectionListGrid(grid);
                                    }}
                                    onApiInitialized={(instance) => {
                                        setInspectionListInstance(instance);
                                    }}
                                    onLoadData={(data) => {
                                        setInspectionListIsEmpty(data.length < 1 ? true : false);
                                    }}
                                    noCreate
                                    noEdit
                                    noDelete
                                    noExcel
                                    onAppendButtonInFrontOfSearch={() => (
                                        <React.Fragment>
                                            <BasicCrudScreenActionItemLayout>
                                                <CreateRecordButton
                                                    id={"MomSysInspectionList-create-button"}
                                                    schema={inspectionListSchema}
                                                    refresh={inspectionListInstance}
                                                    onSuccess={onSuccess}
                                                />
                                                <DeleteRecordButton
                                                    id={"MomSysInspectionList-delete-button"}
                                                    schema={inspectionListSchema}
                                                    grid={inspectionListGrid}
                                                    refresh={inspectionListInstance}
                                                    color="secondary"
                                                    disabled={inspectionListIsEmpty}
                                                    onSuccess={onSuccess}
                                                    onFailure={onFailure}
                                                />
                                            </BasicCrudScreenActionItemLayout>
                                        </React.Fragment>
                                    )}
                                />
                            ) : (
                                <React.Fragment></React.Fragment>
                            )}
                        </ReflexElement>
                    </ReflexContainer>
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

export default MomSysInspectinEntity;
